import ExperienceFacetModal, { FacetOption } from './ExperienceFacetModal';
import { ExperienceScope } from './ExperienceScopeSelector';

const getInitials = (name: string) => {
  const parts = name.split(' ');
  if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  return name.substring(0, 2).toUpperCase();
};

const renderLeadLabel = (option: FacetOption) => (
  <>
    <div style={{
      width: 22, height: 22, borderRadius: '50%', backgroundColor: '#eee',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontSize: 9, fontWeight: 700, color: '#888', flexShrink: 0,
      overflow: 'hidden',
    }}>
      {option.profilePicture ? (
        <img
          alt={option.label}
          src={'https://d378wr66tg5qg7.cloudfront.net/' + option.profilePicture}
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      ) : getInitials(option.label)}
    </div>
    <span style={{ fontSize: 14, color: '#333' }}>{option.label}</span>
  </>
);

interface Props {
  visible: boolean;
  onClose: () => void;
  onSave: (keys: string[], labels: string[], scope: ExperienceScope, operator: 'and' | 'or') => void;
  options: FacetOption[];
  initialSelected: string[];
  initialScope?: ExperienceScope;
  initialOperator?: 'and' | 'or';
  onScopeChange?: (scope: ExperienceScope) => void;
}

const MatterLeadFilterModal = (props: Props) => (
  <ExperienceFacetModal
    {...props}
    title="Responsible Partners"
    description="Find people who have worked on matters led by a specific partner"
    color="#E74C8B"
    searchPlaceholder="Search by name..."
    emptyLabel="No partners selected"
    renderLabel={renderLeadLabel}
  />
);

export default MatterLeadFilterModal;
